import React, { useContext, useMemo } from "react";
import {
  selected, multiple, smallFonts, singleCategory,
  badge, saleMessage, triangle, saleMessageParent,
  parentVariantImg, variantsOnSliderContainer, singleCategoryNoBorders,
  variantCategoryTitle, activeVariantCat
} from "./style.mod.scss";
import ProductContext from "services/product-context";
import { Link } from "gatsby";
import getImagePath from "helpers/get-image-path";
import * as style from "components/pdp-variations/pdp-variants/style.mod.scss";
import locales from "locales";
import VariantCategoryDetails from "components/variant-category-details";

const isVariant = (cat) => cat._type === "productVariant";

const getFirstLeaf = (node) => {
  if (node.children.find(isVariant) !== undefined || node.children.length === 0) return node;

  return getFirstLeaf(node.children[0]);
};

const VariantCategoryLevel = (props) => {
  const { categories, variants } = props;
  const { handle, currentVariant } = useContext(ProductContext);
  const isLeaf = useMemo(() => categories.find(isVariant) !== undefined, [categories]);
  if (isLeaf) return null;

  const children = categories.map((cat) => cat.children).flat().filter((cat) => cat !== undefined);
  const handleVariantChange = (cat) => {
    const leaf = getFirstLeaf(cat);

    const variant = variants.find((variant) => variant.variantCategory?._ref === leaf._id);

    return `/products/${handle}/${variant?.handle?.current}`;
  };

  const selectedClass = (cat) => cat.selected ? `${selected} ${style.selectedCat}` : "";
  const smallFontsClass = (cat) => cat?.smallFonts ? smallFonts : "";
  let selectedParent;
  let parentTwoVariants;
  let variantsOnSlider;
  let allVariants;

  const isPanOnSale = (variant) => 
    variant?.cluster === "Pan-Coated" && variant.cartTitle == "Die Kupferkernpfanne" &&
    (variant.category.title == "26 cm" || variant.category.title == "30 cm ");

  return (
    <>
      {categories?.length > 0 &&
        <>
          {categories?.filter((cat) => cat.selected || !cat.parent || (!cat.selected && cat.parent.selected)).map((cat) => {

            const categoryInformation = cat?.parent?.parentCategoryInfo;
            const selectedCategory = cat?.selected;
            const parent = cat?.parent;
            selectedParent = parent?.selected;
            parentTwoVariants = parent?.twoVariant;
            variantsOnSlider = parent?.variantsOnSlider;
            allVariants= parent?.variantsInOneLine;

            return (
              <React.Fragment key={cat._id}>{(categoryInformation?.showQuestion && selectedCategory) &&
                <VariantCategoryDetails content={categoryInformation}/>}
              </React.Fragment>
            );
          })
          }
          {variantsOnSlider &&
          <p className={variantCategoryTitle}><strong>{locales?.products?.contents}:</strong> {currentVariant?.variantTitle} </p>}
          <ul className={
            `${selectedParent && parentTwoVariants ? style.twoVariantsRow : ""}
            ${variantsOnSlider ? variantsOnSliderContainer : ""}
            ${allVariants ? style.variantsInOneLine : ""}
            ${categories?.length === 1 ? singleCategoryNoBorders : ""}
            ${categories?.length > 8 ? `${style.multipleCategories} ${multiple}` : multiple}`
          }>
            {
              categories.filter((cat) => cat.selected || !cat.parent || (!cat.selected && cat.parent.selected)).map((cat) => {
                const variant = variants.find(v => v.variantCategory?._ref === cat._id);

                return (
                  <li className={`
                    ${selectedClass(cat)} 
                    ${smallFontsClass(cat)}
                    ${singleCategory}
                    ${cat?.activeCategory ? activeVariantCat : ""}
                    ${cat?.parentCategoryImage?.asset ? parentVariantImg : ""}`}
                  key={cat._id}>
                    
                    {variant && isPanOnSale(variant) && (
                      <span className={saleMessage}>
                        <div className={saleMessageParent}>
                          %
                          <span className={triangle}></span>
                        </div>
                      </span>
                    )}

                    <Link to={handleVariantChange(cat)} state={{ preserveScroll: true }} role="button">
                      {cat.icon && <img srcSet={getImagePath(cat?.icon, true)} alt={cat?.icon?.alt} />}
                      {cat?.parentCategoryImage?.asset ? <img src={getImagePath(cat?.parentCategoryImage)} alt={cat?.parentCategoryImage?.alt}/> : <span>{cat.title}</span>}
                    </Link>
                    {cat?.newBadge && <img className={badge} src={getImagePath(cat?.badge)} alt={cat?.badge?.alt} />}
                  </li>
                );
              })
            }
          </ul>

        </>
      }
      {!isLeaf && children.length !== 0 && <VariantCategoryLevel
        categories={children}
        variants={variants}
      />}
    </>
  );
};

export default VariantCategoryLevel;
